import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  width: 100%;

  display: flex;
  flex-direction: column;

  text-align: center;
  font-family: 'Inter';
  font-size: 12px;
  line-height: 18px;
  color: ${props => props.theme.colors.color545e6c};
`

export const Title = styled.h3`
  font-weight: 600;
`

export const Disclaimer = styled.span`
  font-weight: 400;
`

export const SupportLink = styled.a`
  color: ${props => props.theme.colors.color378ff7};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    filter: brightness(0.9);
  }
`
